import React from 'react';
import compose from '../../utils/compose'
import {OrderMessages} from '../../utils/constUtils'
import withNofeshService  from '../../hoc/withNofeshService.hoc';
import { Redirect  } from "react-router-dom";

class ModalOrderDisplay extends React.Component {

    timer = 0;

    state = {
        redirect:null,
        IsCouplingRooms:false,
        HasConnectionDoor:false,
        errorMsg:''

    }



    componentDidMount() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
            });

            
        console.log('ModalOrderDisplay componentDidMount props: ', this.props);     

    }


    HasConnectionDoorChange = e => {
        console.log('e.currentTarget.value', e.currentTarget.value);
        let t = this.state.HasConnectionDoor;
        this.setState( {HasConnectionDoor:!t} );
    };


    CouplingRoomsChange = e => {
        let t = !this.state.IsCouplingRooms;
        this.setState( {IsCouplingRooms:t} );
        console.log('CouplingRoomsChange t', t);
    };


    doCancelOrder = () => {
        //const { employeeOrder } = this.props;
        //console.log('doCancelOrder clicked ');
        //this.props.doCancelOrder(employeeOrder.Id);

        this.props.doCancelOrderConfirm();

    }


    setModalOrderClosed = () =>  {
        this.setState({ redirect: "/orders" }); 
    }

  render() {

    if (this.state.redirect) {        
        return <Redirect to={this.state.redirect} />
    } 

    const { employeeOrder } = this.props;
    return (

            <div className="cntered-flex">
                <React.Fragment >      
                    <div className="modal_main_bg" ></div>
                    <div className="cntered-flex">
                        <div className="modal_order_bg_2">

                            <div className="close_arrow pointer zindex1000" onClick={this.setModalOrderClosed}></div>

                            <div className="modal_order_inner_bg">
                                <div className="modal_order_top">                            
                                    <div className="modal_order_title1">                             
                                    מס' הזמנה
                                    &nbsp;
                                    {employeeOrder.Id}

                                    </div>      
                                </div>

                                <div className="modal_order_title_hotel">
                                    מלון
                                    &nbsp;
                                    {employeeOrder.HotelName}
                                </div>
                                <div className="cntered-flex">
                                    <div className="modal_order_title_second">
                                        <span> </span>
                                        <span className="modal_order_err1"> {this.state.errorMsg}</span>
                                    </div>
                                    
                                </div>

                                <div className="modal_order_grid_container">
                                    <div className="modal_order_grid_inner_container directionRtl">

                                        <div className="modal_order_grid_inner_col">
                                            <div className="modal_order_grid_inner_col_right_box">                                                
                                                <div className="modal_order_right_grid">
                                                    <div className="">
                                                        <div className="inner_middle_box" >
                                                            <div className="modal_order_left_grid_font2 ">
                                                                <span className="directionRtl">
                                                                {employeeOrder.EndVacationDateFormatted}
                                                                -
                                                                {employeeOrder.StartVacationDateFormatted}
                                                                
                                                                </span>
                                                            </div>
                                                            <div className="modal_order_left_grid_font2">
                                                                  לילות
                                                                 &nbsp;
                                                                {employeeOrder.TotalNights}
                                                                &nbsp;
                                                                {employeeOrder.WeekPeriodDescription}

                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="">
                                                        <div className="inner_middle_box" >
                                                            <span className="modal_order_left_grid_font1">תאריכים</span>
                                                        </div>
                                                    </div>
                                                </div>                                                
                                                <div className="model_order_line2"></div>
                                                
                                                <div className="modal_order_right_grid">
                                                    <div className="">
                                                        <div className="inner_middle_box" >
                                                            <div className="modal_order_left_grid_font2 directionRtl">
                                                                {employeeOrder.NumberOfAdults}
                                                                &nbsp;
                                                                מבוגרים
                                                                ,
                                                                {employeeOrder.NumberOfChildren}
                                                                &nbsp;
                                                                ילדים
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="">
                                                        <div className="inner_middle_box" >
                                                            <span className="modal_order_left_grid_font1">אורחים</span>
                                                        </div>
                                                    </div>
                                                </div>                                                
                                                <div className="model_order_line2"></div>

                                                <div className="modal_order_right_grid">
                                                    <div className="">
                                                        <div className="inner_middle_box" >
                                                            <div className="modal_order_left_grid_font2"> 
                                                            {employeeOrder.RoomsNum}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="">
                                                        <div className="inner_middle_box" >
                                                            <span className="modal_order_left_grid_font1">חדרים</span>
                                                        </div>
                                                    </div>
                                                </div>                                                
                                                <div className="model_order_line2"></div>
                                                
                                                <div className="modal_order_right_grid">
                                                    <div className="">
                                                        <div className="inner_middle_box" >
                                                            <div className="modal_order_left_grid_font2"> 
                                                            {employeeOrder.HostBase}
                                                            
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="">
                                                        <div className="inner_middle_box" >
                                                            <span className="modal_order_left_grid_font1 ">בסיס אירוח</span>
                                                        </div>
                                                    </div>
                                                </div>                                                
                                                <div className="model_order_line2"></div>

                                            </div>
                                        </div>


                                        <div className="modal_order_grid_inner_col_left" >

                                            <div className="modal_order_grid_inner_col_left_inner">
                                                <div className="modal_order_grid_font1">בקשות מיוחדות</div>
                                                <div>
                                                    אנו נשתדל למלא בקשות מיוחדות, אך לא נוכל להתחייב לכך.
                                                </div>
                                                <div>
                                                    <div className="check-form-group">
                                                        <input 
                                                            type="checkbox" 
                                                            id="chk1"
                                                            defaultChecked={employeeOrder.IsCouplingRooms}
                                                            
                                                        ></input>
                                                        <label htmlFor="chk1">חדרים צמודים</label>
                                                    </div>
                                            
                                                </div>
                                                <div>


                                                    <div className="check-form-group">
                                                        <input 
                                                            type="checkbox" 
                                                            id="chk2"
                                                            defaultChecked={employeeOrder.HasConnectionDoor}
                                                            
                                                        ></input>
                                                        <label htmlFor="chk2">דלת מקשרת </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="modal_order_grid_inner_col_left_inner marginTop10">
                                                <div className="modal_order_grid_font1">מדיניות ביטולים</div>
                                                <div>
                                                ניתן לבטל את ההזמנה עד שלושה שבועות לפני מועד ההזמנה.
                                                </div>
                                            </div>

                                            <div className="modal_order_grid_inner_col_left_inner marginTop10">
                                                <div className="modal_order_grid_font1">ספק  </div>
                                                <div>
                                                {employeeOrder.SupplierName}

                                                <br />
                                                מס' שובר של ספק
                                                &nbsp;
                                                {employeeOrder.VoucherNumber}
                                                </div>
                                            </div>

                                            
                                            <div className="marginTop14">

                                                {(this.props.employeeOrder.CanCancelOrder) ? 
                                                    <div className="cntered-flex ">
                                                        <div className="hp_search_main_button marginTop20"
                                                                onClick={() => this.doCancelOrder()}>
                                                            <span className="hp_search_main_button_title">
                                                            ביטול הזמנה
                                                            </span>
                                                        </div>
                                                    </div>
                                                    :
                                                    <div className="modal_order_grid_inner_col_left_inner"> 
                                                        <span className="errorMsg">
                                                            לא ניתן לבטל הזמנה זו.
                                                        </span>

                                                    </div>
                                                }
                                            </div>
                                        </div>


                                    </div> 
                                </div>
                            </div>
                        </div>
                    </div>                
                </React.Fragment>
            </div>
    );
  }
}



export default compose(
    withNofeshService(),    
  )(ModalOrderDisplay);
